import {
  useCallback,
  useEffect,
  useRef,
  useState
} from 'react';

import { captureMessage } from '@sentry/react';
import { getObjects } from '@/api';
import useApiCall from '@/hooks/useApiCall';
import useElementEvent from '@/hooks/useElementEvent';
import { appendToList } from '@/utils/tools';

interface ObjectsLoaderProps {
  lang?: string;
  selected?: Record<string, unknown>;
  type?: string;
}

interface ObjectsResult {
  items: string[];
  has_next: boolean;
}

const ObjectsLoader = ({
  lang,
  selected,
  type
}: ObjectsLoaderProps) => {
  const [page, setPage] = useState(2);

  const buttonRef = useRef<HTMLElement | null>(null);

  const onSuccess = useCallback((response: { data?: { result?: ObjectsResult } }) => {
    const result = response.data?.result;

    if (!result) {
      captureMessage('ObjectsLoader: empty result from API', { level: 'warning' });
      return;
    }

    appendToList('#houses-list', result.items);

    if (!result.has_next && buttonRef.current) {
      (buttonRef.current as HTMLElement).style.display = 'none';
    }

    setPage((prevPage) => prevPage + 1);
  }, []);

  const onSubmit = useCallback(() => {
    const options = {
      ...selected,
      lang,
      page
    };
    return getObjects(type ?? '', options);
  }, [lang, page, selected, type]);

  const {
    callback,
    processing
  } = useApiCall(onSubmit, onSuccess);

  useEffect(() => {
    buttonRef.current = document.querySelector('#sale-rental-load-more');
  }, []);

  useEffect(() => {
    if (buttonRef.current) {
      (buttonRef.current as HTMLButtonElement).disabled = processing;
    }
  }, [processing]);

  useElementEvent('#sale-rental-load-more', callback);

  return null;
};

export default ObjectsLoader;
